import { VehiclesWithUnidentifiedEventsList } from "./VehiclesWithUnidentifiedEventsList";
import HelpOutlineOutlinedIcon from "@material-ui/icons/HelpOutlineOutlined";

export default {
  icon: HelpOutlineOutlinedIcon,
  list: VehiclesWithUnidentifiedEventsList,
};
